import React from 'react'
import PropTypes from 'prop-types'
import { Navigate as Redirect } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isNil } from 'lodash'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/SharedBusinessRules'
import validationActions from '../../actions/SharedBusinessRulesValidation'
import createFlashMessage from '../../actions/FlashMessages/createFlashMessage'
import SharedBusinessRuleForm from './SharedBusinessRuleForm'

export class SharedBusinessRuleEdit extends Component {
  static propTypes = {
    params: PropTypes.object,
    update: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    show: PropTypes.func.isRequired,
    showReset: PropTypes.func.isRequired,
    createValidation: PropTypes.func,
    resetValidation: PropTypes.func,
    requestInProgress: PropTypes.bool,
    resourceErrors: PropTypes.object,
    resourceErroredFields: PropTypes.array,
    attributes: PropTypes.object,
    updated: PropTypes.bool.isRequired,
    createFlashMessage: PropTypes.func.isRequired,
    configuration: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.props.show(this.id)
  }

  componentWillUnmount() {
    this.props.reset()
    this.props.showReset()
    this.props.resetValidation()
  }

  get id() {
    return this.props.params.id
  }

  handleSubmit = async (values) => {
    const response = await this.props.update(this.id, values)

    if (isNil(response.resourceErrors)) {
      this.props.createFlashMessage('Updated business rule', { id: parseInt(this.id, 10), tag: 'index' })
    }
  }

  redirect(path) {
    return <Redirect replace to={path} />
  }

  render() {
    const {
      attributes,
      updated,
      requestInProgress,
      resourceErrors,
      resourceErroredFields,
      configuration
    } = this.props

    if (isNil(attributes)) {
      return null
    }

    if (updated) {
      return this.redirect('/business_rules')
    }

    return (
      <div className="content">
        <h2>Edit Business Rule</h2>
        <div>
          <SharedBusinessRuleForm
            businessRuleTypes={configuration.business_rule_types}
            matchingTypes={configuration.matching_types}
            resourceErrors={resourceErrors}
            resourceErroredFields={resourceErroredFields}
            requestInProgress={requestInProgress}
            createValidation={this.props.createValidation}
            id={this.id}
            initialValues={attributes}
            handleSubmit={this.handleSubmit}
            submitLabel="Edit Business Rule"
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const configuration = state.login.session.configuration.shared_business_rules
  const slice = state.sharedBusinessRules.update
  const showSlice = state.sharedBusinessRules.show
  const resourceErrors = state.sharedBusinessRules.update.resourceErrors || {}

  return {
    generalError: slice.generalError,
    resourceErroredFields: Object.keys(resourceErrors),
    requestInProgress: slice.requestInProgress,
    attributes: showSlice.attributes,
    id: slice.id,
    updated: slice.updated,
    resourceErrors,
    configuration
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  update: actions.update.main,
  reset: actions.update.reset,
  show: actions.show.main,
  showReset: actions.show.reset,
  createValidation: validationActions.create.main,
  resetValidation: validationActions.create.reset,
  createFlashMessage
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SharedBusinessRuleEdit))
